import { useQuery } from '@tanstack/react-query';
import { getWorkEnvironmentMeasurements } from '../../api/workEnvironmentQueries';

export const WorkEnvironmentMeasurementsQueryKey = 'WORK_ENVIRONMENT_MEASUREMENTS';

export const useWorkEnvironmentMeasurementsQuery = (surveyId: number) =>
  useQuery({
    queryKey: [WorkEnvironmentMeasurementsQueryKey, surveyId],
    queryFn: () => getWorkEnvironmentMeasurements(surveyId),
  });
